<template>
  <div class="container-768">
    <div class="home-page pt-20">
      <div class="page-header">
        未承認一覧
      </div>
      <div class="meeting-page clearfix">
        <div class="meeting-categories">
          <div class="explanation-checkbox text-center pt-15 pb-15 pl-20 pr-20">
            一覧に表示する予約の種類を指定できます
          </div>
          <div class="item" v-for="category in categories" :key="category.id" @click="selectCategories(category.id)">
            <span class="check-box" :style="`border-color: ${category.color}; background-color:${category.color}`">
              <span v-show="searchParams && searchParams.categoryIds.findIndex(n => n === category.id) !== -1"></span>
            </span>
            <span class="label" :style="`color: ${category.color}`">{{category.name_kanji}}</span>
          </div>
        </div>

        <div class="meetings-list">
          <ListPendingMeeting />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import {mapActions, mapGetters} from 'vuex'
import ListPendingMeeting from '@/components/meetings/ListPendingMeeting'
import moment from 'moment'
import {apiErrorDialog} from '../helpers'

export default {
  components: {ListPendingMeeting},
  computed: {
    ...mapGetters({
      categories: 'meetings/reservationCategories',
      searchParams: 'meetings/searchParams'
    })
  },
  watch: {
    categories: function (val) {
      if (val.length > 0) {
        this.searchParams.categoryIds = [-1, ...val.map(n => n.id)]
        let searchParams = this.searchParams
        searchParams.month = moment().month() + 1
        const callbacks = {error: (_error) => apiErrorDialog(this, _error)}
        this.fetchMeetingItems({params: searchParams, callbacks: callbacks})
      }
    }
  },
  methods: {
    ...mapActions({
      fetchMeetingItems: 'meetings/fetchMeetings'
    }),
    async selectCategories (cateId) {
      const loading = this.$loading.show()
      let searchParams = this.searchParams
      const index = _.findIndex(searchParams.categoryIds, n => n === cateId)
      if (index === -1) {
        searchParams.categoryIds = [...searchParams.categoryIds, cateId]
      } else {
        _.remove(searchParams.categoryIds, n => n === cateId)
        searchParams.categoryIds = [...searchParams.categoryIds]
      }
      const callbacks = {error: (_error) => {
        loading.hide()
        apiErrorDialog(this, _error)
      }}
      await this.fetchMeetingItems({params: searchParams, callbacks: callbacks})
      loading.hide()
    }
  },
  async mounted () {
    if (this.categories.length > 0) {
      const loading = this.$loading.show()
      this.searchParams.month = moment().month() + 1
      this.searchParams.categoryIds = [-1, ...this.categories.map(n => n.id)]
      this.searchParams.status = 'pending'
      const callbacks = {error: (_error) => {
        loading.hide()
        apiErrorDialog(this, _error)
      }}
      await this.fetchMeetingItems({params: this.searchParams, callbacks: callbacks})
      loading.hide()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/PendingMeeting.vue